<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1794153" style="color: #82a339"><b>CREAM OF ASPARAGUS SOUP</b></p>
<p class="ext" id="d7e1794653"><b><i>For the most flavor, choose the thickest asparagus you can find for this creamy soup. If you wish, garnish each serving with a sprinkling of snipped fresh chives or chopped tarragon or parsley.</i></b></p>
<p class="h4" id="d7e1796253" style="color: #496210"><b>Prep: 10 minutes Cook: 25 to 30 minutes</b></p>
<p class="ul" id="d7e1796853">2 tablespoons butter or margarine</p>
<p class="ul" id="d7e1797153">1 medium onion, chopped</p>
<p class="ul" id="d7e1797453">12 ounces asparagus, trimmed and cut into <br/> 1-inch pieces (3 cups)</p>
<p class="ul" id="d7e1798053">3 tablespoons all-purpose flour</p>
<p class="ul" id="d7e1798353">¼ teaspoon salt</p>
<p class="ul" id="d7e1799353">⅛ teaspoon ground black pepper</p>
<p class="ul" id="d7e1800253">1 can (14½ ounces) chicken or vegetable broth or <br/>1¾ cups Chicken Broth or Vegetable Broth</p>
<p class="ul" id="d7e1802953">1 cup half-and-half or light cream</p>
<p class="pub" id="d7e1803453" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 3-quart saucepan, melt butter over medium heat; add onion and cook, stirring frequently, until tender and golden, about 10 minutes. Add asparagus; cook 1 minute.</p>
<p class="pub" id="d7e1805153"><span style="color: #c15b49"><b>2.</b></span> Stir in flour, salt, and pepper until blended. Gradually stir in broth; heat to boiling, stirring constantly. Reduce heat; cover and simmer until asparagus is tender, 5 to 10 minutes.</p>
<p class="pub" id="d7e1807253"><span style="color: #c15b49"><b>3.</b></span> Spoon half of mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour into bowl. Repeat with remaining mixture.</p>
<p class="pub" id="d7e1809153"><span style="color: #c15b49"><b>4.</b></span> Return puree to saucepan; stir in half-and-half. Heat through (do not boil). Serve soup hot, or cover and refrigerate to serve chilled later. If chilled soup is too thick, stir in some milk. Makes about 5 cups or 4 first-course servings.</p>
<p class="ntx" id="d7e1811553">Each serving: About 194 calories, 6g protein, 14g carbohydrate, 14g total fat (8g saturated), 38mg cholesterol, 657mg sodium.</p>
<p class="h4l" id="d7e1814253" style="color: #496210"><b>CREAM OF CAULIFLOWER <br/> OR BROCCOLI SOUP</b></p>
<p class="tx1" id="d7e1815053">Prepare as directed above but substitute <b>3 cups small cauliflower or broccoli flowerets</b> for asparagus. Use <b>1¼ cups half-and-half or light cream</b> and add <b>dash of ground red pepper.</b> If desired, stir in <b>4 ounces sharp Cheddar cheese,</b> shredded (1 cup) and <b>½ teaspoon Dijon mustard</b> when heating through. Makes about 5 cups or 4 first-course servings.</p>
<p class="h4l" id="d7e1821153" style="color: #496210"><b>CREAM OF MUSHROOM SOUP</b></p>
<p class="tx1" id="d7e1821753">Prepare as directed above but substitute <b>1 pound mushrooms,</b> trimmed and sliced for asparagus. Makes about 4½ cups or 4 first-course servings.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c48_r1.vue?3fa83271